import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cb.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/mastercard.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/visa.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paypal.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/4_credit_card.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/installments.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_fr.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_de.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_en.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_es.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_it.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_nl.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_pt.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_check.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/ideal.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sofort.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bcmc.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sequra.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/maestro.svg';
export default {
  name: 'Payment',
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: {
    setLanguage: function setLanguage(link) {
      if (link === 'bank_transfer') {
        return "_".concat(this.locale.language);
      }

      return '';
    }
  }
};